export class Login {
    constructor() {
        this.mode = 'voucherInactiv';
        this.ces = document.querySelectorAll('.loginBlock');
        this.disabled = document.querySelectorAll('.disabled');

        this.init();
    };

    init() {
        if(this.mode) {
            this.blockOrHide();
        }
    };

    blockOrHide() {
        let block = false;
        this.ces.forEach(ce => {
            if(block) {
                ce.classList.add(this.mode);
            }
            if(ce.classList.contains('loginregister')) {
                block = true;
            }
        });
    }

    unblock() {
        this.ces.forEach(ce => {
            ce.classList.remove(this.mode);
        });

        this.disabled.forEach(ce => {
            ce.classList.remove('.disabled');
        });
    }
}
